import { Component, Input, OnInit } from '@angular/core';
import { getNoteAttachmentState } from '@collections/attachments';
import { getUsersLoggedIn } from '@collections/users';

import { upsertNotesFilters } from '@modules/notes/filters-store/notes-filters.actions';
import { Store } from '@ngrx/store';
import { User } from '@shared';
import { Pagination } from '@shared/pagination';

import {
  Note,
  NoteCategories,
  NoteSubject,
  getNotesPagination,
  getNoteStateLoading,
} from 'mojo-irp-notes';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { notesOpenModal } from '../../store';

@Component({
  selector: 'mojo-notes-list',
  templateUrl: './notes-list.component.html',
  styleUrls: ['./notes-list.component.scss'],
})
export class NotesListComponent implements OnInit {
  @Input() subjectId: number;
  @Input() subjectType: NoteSubject;
  @Input() isForHiringTeamTab = false;
  @Input() isForRecruitingTeamTab = false;
  @Input() fullpage = true;
  @Input() notes: { note: Note; user: User }[];
  @Input() sideDrawerConfiguration = false;

  pagination$: Observable<Pagination<Note>>;
  loggedIn$ = this.store.select(getUsersLoggedIn);
  loading$ = this.store.select(getNoteStateLoading);
  draft = NoteCategories.Draft;

  isDeletingNote$ = this.store
    .select(getNoteAttachmentState)
    .pipe(map((state) => state.isDeleting));

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.pagination$ = this.store.select(getNotesPagination, { notesType: this.subjectType });
  }

  openEditModal(event) {
    event.note.teamMembers = event.note.teamMembers?.filter((t) => t.id !== event.authorId);
    const data = {
      author: event.author,
      authorId: event.authorId,
      subjectId: this.subjectId,
      subject: this.subjectType,
      isEditMode: true,
      note: event.note,
    };
    this.store.dispatch(notesOpenModal({ data }));
  }

  setPageNumber(pageNumber: number) {
    this.store.dispatch(
      upsertNotesFilters({
        notesFilters: {
          pageNumber,
        },
      }),
    );
  }
}
